/* created by CoolGuy on 2018/12/3 */
import React, { createRef, useRef } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { formatImage } from '../../utils/util';
import { style } from '../../utils/image';
import { getSource } from '../../utils/video';
import stat from '../../utils/stat';
import galleryAction from '../../actions/gallery';
import { IComponentVideoHead } from '../../component';
import StatisticsRow from '../StatisticsRow';
import StatusTag from '../Tag/StatusTag';
import { IGalleryStatus } from '../../global.d';
import X5Video from '../ComponentVideo/X5Video';
import intl from 'react-intl-universal';
import { isFullScreen, requestFullScreen } from '../../utils/dom';

interface IHeadVideo {
  index: number;
  imagecount?: number;
  imageview?: number;
  total?: boolean;
  status?: IGalleryStatus;
  disabled?: boolean; // 当前是否可以点击播放，主要用于ComponentVideo,如果playin是false的话不需要启动播放，因为要跳转页面
  fullscreen?: boolean; // 是否全屏播放
  mediaList?: any;
  videoid?: any;
  showData?: boolean;
  theOne?: any;
  islive?: boolean;
}

@inject('rootStore')
@observer
class HeadVideo extends React.Component<IComponentVideoHead & IHeadVideo, any> {
  static defaultProps = {
    index: 0,
    imagecount: 0,
    imageviews: 0,
    total: true,
    showData: true
  };
  video: any;
  videoEle = createRef<HTMLVideoElement>();

  @observable showBg = true;
  @observable zIndex = 1;
  @observable coverHeight = 210;
  @action setBgVisible = (flag: boolean) => {
    this.showBg = typeof flag === 'boolean' ? flag : !this.showBg;
  };
  // 苹果浏览器上必须将zIndex设置成>=2的值，才能够挡住下面的.head-bottom
  // .head-bottom 在安卓上一定会被video挡住
  // 注意，这里的zIndex如果大于10，请必须修改Video.scss的.view-row 的zIndex，否则会被遮挡
  @action setZIndex = () => {
    this.zIndex = 1;
  };
  @observable count = 0;
  @action setCount = (count: number) => (this.count = count);

  onPlay = () => {
    // stat.event('video_play', this.props.videoid || 'head');
  };
  fullScreenListener = () => {
    [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'MSFullscreenChange'
    ].forEach(event => {
      document.addEventListener(event, this.dispatchTabHeightChangeEvt);
    });
  };
  removeFullScreenListener = () => {
    [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'MSFullscreenChange'
    ].forEach(event => {
      document.removeEventListener(event, this.dispatchTabHeightChangeEvt);
    });
  };
  dispatchTabHeightChangeEvt = () => {
    window.dispatchEvent(new Event('custom-tab-height-change'));
  };
  play = () => {
    let { status, disabled, fullscreen, islive } = this.props;
    // 不需要播放
    if (disabled === true) {
      return;
    }
    const { uiStore } = this.props.rootStore!;
    const { showBasicDialog } = uiStore;
    if (!islive) {
      if (status === IGalleryStatus.wait) {
        showBasicDialog(intl.get('The live video is not started'));
        return;
      }
      if (status === IGalleryStatus.rollback) {
        showBasicDialog(intl.get('The live video is waiting replay'));
        return;
      }
    }
    // 需要延时之后才能正常修改高度
    setTimeout(() => {
      this.dispatchTabHeightChangeEvt();
    }, 300);

    console.log('fullscreen?', fullscreen, this.video);
    // 判断条件统一采用this.video,有他的时候使用他，否则是默认的video
    if (this.video) {
      setTimeout(() => {
        if (this.video) {
          try {
            // 因为一开始时是隐藏的，所以当前video的包装元素也是隐藏的，这里需要手动设置一下
            // 没找到好的办法，先这么处理了，主要是一开始的video是隐藏的，然后这里需要显示出来
            // 而又没办法一开始就加载video（某些手机浏览器上会出现视频区域）
            const el = this.video.el();
            el.style.display = 'block';
            const videoIndex = Array.from(el.children).findIndex(
              (one: any) => one.nodeName.toUpperCase() === 'VIDEO'
            );
            if (videoIndex !== -1) {
              el.children[videoIndex].style.display = 'block';
            }
          } catch (e) {}
          this.video.play();
          if (fullscreen) {
            this.removeFullScreenListener();
            this.fullScreenListener();
            this.video.requestFullscreen();
          }
        }
      }, 100);
    } else {
      if (this.videoEle && this.videoEle.current) {
        const player = this.videoEle.current;
        player.play();
        // 目前测试发现安卓机（1+6 android 9)上可以通过这种方式进行全屏，但是IOS不一样，通过直接设置X5的属性完成这个操作
        // 注意，不能将这部分代码移动到player.play().then里边，因为不明的原因，在一加6里边，只要在这之后执行requestFullScreen，都无法
        // 正常全屏
        // 注意，经测试，requestFullScreen必须在play之后执行，否则在某些手机上（比如小米8）会偶现白屏没有看到视频（实际上已经在播放，有声音）的情况
        if (fullscreen) {
          this.removeFullScreenListener();
          this.fullScreenListener();
          // 实验发现，立即调用rFS会在某些手机上看到白屏，所以这里做一个延时后再试，测试发现0也是OK的
          // this.videoEle.current && requestFullScreen(this.videoEle.current);
        }
      }
    }

    this.setBgVisible(false);
    this.setZIndex();
  };

  getVideoCount = () => {
    // 现在获取视频浏览量，不能再发这个接口了，超慢无比 - 20191217 zihan
    // galleryAction
    //   .eventShow({
    //     event: 'video_play',
    //     option: 'galleryid=' + window.gallery.id + '&id=head'
    //   })
    //   .then(res => {
    //     if (res && res.count) {
    //       this.setCount(res.count);
    //     }
    //   });
    try {
      if (this.props.videoid && this.props.mediaList) {
        const theOne = this.props.mediaList.data.items.find(
          (media: any) => +media.id === +this.props.videoid
        );
        if (theOne) {
          // setCount(theOne.view);
          // view = theOne.view;
          return theOne.view * 1;
        }
      }
    } catch (e) {}

    return 0;
  };

  onClick = () => {
    console.log('video on click');
    window.dispatchEvent(new Event('custom-tab-height-change'));
  };

  componentWillUnmount(): void {
    // clearInterval(this.eventTimer);
    this.removeFullScreenListener();
    // 官方提供的destroy
    // https://docs.videojs.com/tutorial-react.html
    this.video && this.video.dispose();
  }

  componentDidMount() {
    if (window.videojs) {
      const { index } = this.props;

      let video_dom = document.getElementById('head_video' + index);
      if (video_dom) {
        this.video = window.videojs('head_video' + index);
        // player.play();
      }
    }
  }

  updateCurrentDomHeight = action((e: any) => {
    e.target.parentNode.style.height = `${e.target.height}px`;
    e.target.parentNode.parentNode.style.height = `${e.target.height}px`;

    this.coverHeight = Math.max(210, e.target.height);

    window.dispatchEvent(new Event('custom-tab-height-change'));
  });

  render() {
    let {
      theOne,
      source,
      thumb,
      imagecount,
      imageviews,
      total,
      status,
      type,
      islive
    } = this.props;
    if (!source) {
      return null;
    }

    let realCount = this.getVideoCount();

    if (islive && status == 'complete') {
      status = IGalleryStatus.rollback;
    } else if (islive && status == 'rollback') {
      status = IGalleryStatus.end;
    }
    if (islive && status == 'config') {
      status = IGalleryStatus.wait;
    }
    return (
      <div className="head-video" style={{ zIndex: this.zIndex }}>
        <X5Video
          id={'head_video' + this.props.index}
          onPlay={this.onPlay}
          ref={this.videoEle}
          fullscreen={this.props.fullscreen}
          style={{
            display: this.showBg ? 'none' : 'block',
            height: this.coverHeight
          }}
          bgToggle={(hide: boolean) => this.setBgVisible(!hide)}
        >
          {getSource(source)}
        </X5Video>
        {this.showBg && (
          <div className={'video-play-wrapper'} onClick={this.play}>
            <img
              src={style(thumb, 'wx_750_n')}
              className={'video-play'}
              onLoad={this.updateCurrentDomHeight}
              alt=""
            />
            <div className="video-player-wrapper">
              {!islive && status === IGalleryStatus.wait ? (
                <div className={'not-started-wrapper'}>
                  {intl.get('The live video is not started')}
                </div>
              ) : !islive && status === IGalleryStatus.rollback ? (
                <div className={'not-started-wrapper'}>
                  {intl.get('The live video is waiting replay')}
                </div>
              ) : (
                <img
                  src={require('../../assets/video-play.png')}
                  alt=""
                  className="video-play-center"
                />
              )}
            </div>
          </div>
        )}
        {this.showBg && !!realCount && this.props.showData && (
          <div className="data">{realCount}</div>
        )}

        {status ? <StatusTag status={status} className={'status-tag'} /> : null}

        {!!total ? (
          <div className="head-bottom">
            <StatisticsRow
              n1={imagecount || 0}
              n2={imageviews || 0}
              fontColor={'#fff'}
            />
          </div>
        ) : null}
      </div>
    );
  }
}
export default HeadVideo;
